<template>
  <div class="gmf-context" v-if="profile && levelList">
    <div class="gmf-level-modal-customer">
      <Avatar :customer="profile"></Avatar>
      <CustomerName class="gmf-subheader" :customer="profile"></CustomerName>
    </div>

    <div class="gmf-level-modal-preview gmf-text-small">
      <div class="gmf-level-modal-level" v-if="currentLevel && currentLevel.level">
        <span>{{ t('profile_card.level') + ' ' + currentLevel.level }}</span>
        <span class="gmf-customer-title">{{ currentLevel.levelName }}</span>
      </div>
      <Icon class="gmf-level-modal-icon" icon="next-level" />
      <div class="gmf-level-modal-level" v-if="nextLevel && nextLevel.level">
        <span>{{ t('profile_card.level') + ' ' + nextLevel.level }}</span>
        <span class="gmf-customer-title">{{ nextLevel.levelName }}</span>
      </div>
    </div>

    <div class="gmf-profile-level-container">
      <div class="gmf-profile-level-bar-outer"><div class="gmf-profile-level-bar-inner" :style="{ width: barWidth }"></div></div>
      <div class="gmf-profile-xp-text gmf-xp">{{ profile.xp - profile.xpToCurrentLevel }} / {{ profile.xpToNextLevel - profile.xpToCurrentLevel }}{{ t('xp') }}</div>
    </div>

    <VerticalSeparator>
      {{ t('level_modal.separator_text') }}
    </VerticalSeparator>
    
    <div class="gmf-level-modal-content">
      <div
        v-for="info in levelInfo"
        class="gmf-level-card gmf-text-small"
        :class="{
          'gmf-locked': info.level > currentLevel.level,
          'gmf-current': info.level === currentLevel.level
        }"
        :key="info.level"
      >
        <span style="font-weight: bold; margin-right: 8px;">{{ t('profile_card.level') + ' ' + info.level }}</span>
        <span class="gmf-customer-title">{{ info.levelName }}</span>
        <span class="gmf-extra-text gmf-text-small" v-if="info.reachedAt">{{ timeAgo(info.reachedAt) }}</span>
        <span class="gmf-extra-text gmf-text-small" v-else-if="info.level === currentLevel.level+1">{{ info.requiredXp - profile.xp + t('xp') + ' ' + t('level_modal.xp_remaining')}}</span>
      </div>
    </div>
  </div>
</template>

<style>
.gmf-level-modal-customer {
  gap: 10px;
  display: flex;
  align-items: center;
  margin-bottom: var(--gmf-p-2);
}
.gmf-level-modal-customer .gmf-avatar {
  width: 40px;
  height: 40px;
}
.gmf-level-modal .gmf-context .gmf-subheader {
  margin-bottom: 0;
}
.gmf-level-card {    
  margin: 5px 0;
  padding: 20px 15px;
  border: 1px solid var(--gmf-col-gray);
  border-radius: var(--gmf-rounding);
}
.gmf-level-card.gmf-locked {
  background: var(--gmf-col-lightgray);
  border: none;
}
.gmf-level-card.gmf-current {
  border: 1px solid var(--gmf-highlight-col);
}
.gmf-level-modal .gmf-vertical-separator {
  margin-bottom: var(--gmf-p-3);
}
.gmf-level-card :nth-child(1) {
  margin-top: 0px;
}
.gmf-level-modal {
  max-width: 480px !important;
  width: 90%;
}
.gmf-level-modal-icon {
  flex-shrink: 0;
}
.gmf-level-modal-content {
  max-height: 500px;
  padding: 0;
}
.gmf-level-modal .gmf-profile-level-container {
  margin: var(--gmf-p-3) 0;
  flex-direction: row;
  gap: 15px
}
.gmf-level-modal .gmf-profile-level-bar-outer {
  flex-grow: 1;
}
.gmf-extra-text {
  width: 100%;
  float: right;
  text-align: right;
}
.gmf-level-modal-preview {
  display: flex;
  gap: var(--gmf-p-2);
  align-items: center;
  justify-content: space-between;
}
.gmf-level-modal-level {
  text-align: center;
}
.gmf-level-modal-level span:first-child  {
  margin-right: var(--gmf-p-2);
}
</style>

<script>
import state from '@/state';
import Icon from '@/components/Icon';
import callApi from '@/utils/callApi';
import timeAgo from '@/utils/timeAgo';
import Avatar from '@/components/Avatar';
import VerticalSeparator from '@/components/VerticalSeparator';
import CustomerName from '@/components/CustomerName';
import { ensureProfileLoaded } from '@/utils/getMyProfile';

const t = state.t;

export default {
  name: 'LevelList',
  components: {
    Icon,
    Avatar,
    CustomerName,
    VerticalSeparator,
  },
  data () {
    return {
      state,
      t,
      levelList: null,
    };
  },
  methods: {
    timeAgo,
  },
  computed: {
    currentLevel () {
      return this.levelList.find(l => l.level == this.profile.customerLevel);
    },
    nextLevel () {
      return this.levelList.find(l => l.level == this.profile.customerLevel+1);
    },
    levelInfo () {
      const levelOffset = 2;
      return this.levelList.filter(level => level.level >= this.currentLevel.level-levelOffset && level.level <= this.currentLevel.level+levelOffset);
    },
    barWidth () { // @TODO replace with progressbar component
      const currentXp = this.profile.xp - this.profile.xpToCurrentLevel;
      const toNextLevel = this.profile.xpToNextLevel - this.profile.xpToCurrentLevel;
      return (currentXp * 100 / toNextLevel).toFixed(2)+'%';
    },
    profile() {
      return this.state.profile;
    }
  },  
  async mounted () {
    await ensureProfileLoaded();

    if (this.profile && this.profile.id) {
      const levelReq = await callApi('GET', '/v1/client/levels/' + this.profile.id);
      const levels = await levelReq.json();

      this.levelList = JSON.parse(JSON.stringify(levels));
    }
  },
};
</script>
